import CustomButton from 'src/components/CustomComponents/CustomButton'

interface ChapterPublishFooterProps {
	publishedStatus: string
	readyToPublish: boolean
	loading?: boolean
	onPublish: () => void
	onUnpublish: () => void
}

function ChapterPublishFooter({
	publishedStatus,
	readyToPublish,
	loading = false,
	onPublish,
	onUnpublish,
}: ChapterPublishFooterProps) {
	const isPublished = String(publishedStatus).toLowerCase() === 'published'
	const disabled = loading || !readyToPublish

	if (isPublished) {
		return (
			<CustomButton
				fullWidth
				onClick={onUnpublish}
				disabled={disabled}
				sx={{
					height: 44,
					border: 'none',
					color: '#fff',
					background: disabled ? '#d1d5db' : '#f59e0b',
					borderRadius: 999,
					':hover': {
						background: disabled ? '#d1d5db !important' : '#d97706 !important',
						color: '#fff',
					},
				}}
			>
				Unpublish now
			</CustomButton>
		)
	}

	return (
		<CustomButton
			fullWidth
			onClick={onPublish}
			disabled={disabled}
			sx={{
				height: 44,
				border: 'none',
				color: '#fff',
				background: disabled ? '#d1d5db' : '#1f7a44',
				borderRadius: 999,
				':hover': {
					background: disabled ? '#d1d5db !important' : '#166534 !important',
					color: '#fff',
				},
			}}
		>
			Publish now
		</CustomButton>
	)
}

export default ChapterPublishFooter
